import { FC } from 'react';

import { PLAN_CARD_TEST_ID } from '../constants';
import { isCallToActionProps, PlanCardModel } from '../model';
import { CTAButton, CTAButtonWrapper } from '../PlanCard.styles';

type Props = { callToAction?: PlanCardModel.CallToActionType } & PlanCardModel.NegativeProp;

export const CallToAction: FC<Props> = ({ callToAction, isNegative }) => {
    if (!callToAction) {
        return null;
    }
    if (isCallToActionProps(callToAction)) {
        return (
            <CTAButton
                variant="primary"
                negative={isNegative}
                disabled={callToAction.disabled}
                loading={callToAction.loading}
                onClick={(event) => callToAction.onClick(event.currentTarget)}
                data-test={PLAN_CARD_TEST_ID.CTA}
            >
                {callToAction.text}
            </CTAButton>
        );
    }

    const Component = callToAction;

    return (
        <CTAButtonWrapper>
            <Component isNegative={isNegative} />
        </CTAButtonWrapper>
    );
};
